import { useState } from "react";
import { getAdminVisitProofsByDateApi } from "../../services/visitProofApi";

const AdminVisitReport = () => {
  const [date, setDate] = useState("");
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSearch = async () => {
    if (!date) return alert("Please select date");

    try {
      setLoading(true);

      const res = await getAdminVisitProofsByDateApi(date);

      // ✅ DIRECT USE (backend already formatted)
      setActivities(res.data.data || []);

    } catch (err) {
      console.log(err);
      alert("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  const totalVisits = activities.length;
  const totalStaff = new Set(activities.map(a => a.staff?.email)).size;

  return (
    <div style={{ padding: 20 }}>

      <h2>📊 Admin Daily Visit Report</h2>

      {/* FILTER */}
      <div style={{ marginBottom: 10 }}>
        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
        <button onClick={handleSearch}>
          {loading ? "Loading..." : "Search"}
        </button>
      </div>

      {/* SUMMARY */}
      <div style={{ marginBottom: 15 }}>
        📍 Total Visits: <b>{totalVisits}</b> | 👨‍💼 Total Staff: <b>{totalStaff}</b>
      </div>

      {/* HEADER */}
      <div style={headerRow}>
        <div>ID</div>
        <div>Time</div>
        <div>Staff</div>
        <div>Lead</div>
        <div>Contact</div>
        <div>Address</div>
        <div>Notes</div>
        <div>Proof</div>
      </div>

      {/* ROWS */}
      {activities.length === 0 ? (
        <p>No data found</p>
      ) : (
        activities.map((act) => (
          <div key={act.activity_id} style={row}>

            <div>{act.activity_id}</div>

            <div>
              {act.created_at
                ? new Date(act.created_at).toLocaleString()
                : "-"}
            </div>

            {/* STAFF */}
            <div>
              {act.staff?.name || "-"}
              <br />
              <small>{act.staff?.email || "-"}</small>
            </div>

            {/* LEAD */}
            <div>
              {act.lead?.shop_name || "-"}
              <br />
              <small>{act.lead?.owner_name || "-"}</small>
            </div>

            <div>{act.lead?.phone || "-"}</div>

            <div>{act.lead?.address || "-"}</div>

            <div>{act.notes || "-"}</div>

            {/* PROOF */}
            <div>
              {act.images?.length > 0 ? (
                act.images.map((img, i) => (
                  <img
                    key={i}
                    src={`${img}`}
                    width="40"
                    style={{ marginRight: 5, borderRadius: 4 }}
                  />
                ))
              ) : (
                <span style={{ color: "red" }}>No proof</span>
              )}
            </div>

          </div>
        ))
      )}
    </div>
  );
};

// styles
const headerRow = {
  display: "grid",
  gridTemplateColumns: "80px 200px 180px 180px 120px 200px 200px 120px",
  fontWeight: "bold",
  borderBottom: "2px solid #000",
  padding: 10
};

const row = {
  display: "grid",
  gridTemplateColumns: "80px 200px 180px 180px 120px 200px 200px 120px",
  borderBottom: "1px solid #ddd",
  padding: 10,
  fontSize: 13
};

export default AdminVisitReport;